import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/home",
    name: "home",
    component: () => import("../views/Home"),
  },
  {
    path: "",
    component: () => import("../views/app/index"),
    children: [
      {
        path: "/fuel-bill/template1",
        name: "fuelbill1",
        component: () => import("../views/FuelMerge"),
      },
      {
        path: "/fuel-bill/template2",
        name: "fuelbill2",
        component: () => import("../views/FuelMerge"),
      },
      {
        path: "/fuel-bill/template3",
        name: "fuelbill3",
        component: () => import("../views/FuelMerge"),
      },
      {
        path: "/fuel-bulk-bill",
        name: "fuelBulkBill",
        component: () => import("../views/FuelMerge"),
      },
      {
        path: "/driver-salary/template1",
        name: "driverbill1",
        component: () => import("../views/DriverSalary"),
      },
      {
        path: "/driver-salary/template2",
        name: "driverbill2",
        component: () => import("../views/DriverSalary"),
      },
      {
        path: "/daily-helper/template1",
        name: "dailyHelperBill",
        component: () => import("../views/DailyHelper"),
      },
      {
        path: "/book-receipt/template1",
        name: "bookbill1",
        component: () => import("../views/BookReceipt"),
      },
      {
        path: "/book-receipt/template2",
        name: "bookbill2",
        component: () => import("../views/BookReceipt"),
      },
      {
        path: "/rent-receipt/template1",
        name: "rentbill1",
        component: () => import("../views/RentReceipt"),
      },
      {
        path: "/rent-receipt/template2",
        name: "rentbill2",
        component: () => import("../views/RentReceipt"),
      },
      {
        path: "/internet-bill/template1",
        name: "internetbill",
        component: () => import("../views/InternetBill"),
      },
      {
        path: "/ecom-bill/template1",
        name: "ecombill",
        component: () => import("../views/EcommBill"),
      },
      {
        path: "/lta-bill",
        name: "ltabill",
        component: () => import("../views/LtaBill"),
      },
      {
        path: "/general-bill",
        name: "generalbill",
        component: () => import("../views/GeneralBill"),
      },
      {
        path: "/restaurant-bill",
        name: "restaurantbill",
        component: () => import("../views/RestaurantBill"),
      },
      {
        path: "/refer-now",
        name: "refernow",
        component: () => import("../views/ReferNow/refer-now"),
      },
      {
        path: "/recharge-bill",
        name: "rechargebill",
        component: () => import("../views/RechargeBill"),
      },
      {
        path: "/medical-bill",
        name: "medicalbill",
        component: () => import("../views/Medical"),
      },
      {
        path: "/stationary-bill",
        name: "stationarybill",
        component: () => import("../views/StationaryReceipt"),
      },
      {
        path: "/cab-bill",
        name: "cabbill",
        component: () => import("../views/CabBill"),
      },
      {
        path: "/mart-bill",
        name: "martbill",
        component: () => import("../views/MartBill"),
      },
      {
        path: "/gym-bill",
        name: "gymbill",
        component: () => import("../views/GymBill"),
      },
      {
        path: "/hotel-bill",
        name: "hotelbill",
        component: () => import("../views/HotelBill"),
      },
      {
        path: "/news-paper-bill",
        name: "newspaperbill",
        component: () => import("../views/NewsPaperBill"),
      },
      {
        path: "/payment",
        name: "payment",
        component: () => import("../views/Payment"),
      },
      {
        path: "/myaccount",
        name: "myaccount",
        component: () => import("../views/MyAccount"),
      },
    ],
  },
  {
    path: "/payment/confirmation",
    name: "payment-confirmation",
    component: () => import("../views/Payment/payment-confirmation"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login"),
  },
  {
    path: "/callback",
    name: "callback",
    component: () => import("../views/Login/Callback.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: "history",
});

function hasQueryParams(route, param) {
  return Object.keys(route.query).indexOf(param) >= 0;
}

router.beforeEach((to, from, next) => {
  if (!hasQueryParams(to, "referCode") && hasQueryParams(from, "referCode")) {
    next({ name: to.name, query: from.query });
  } else {
    next();
  }
});

export default router;
